<template>
    <div>
        <div class="card border-primary mb-3">
            <div class="card-body">
                <div class="row">
                    <div class="form-group col-sm-12 col-md-6">
                        <label
                            class="font-weight-bold required"
                            :for="'participationRelationTypeName' + _uid"
                        >{{$t('participationRelationType.gridHeaders.name')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.name"
                            v-validate="'required'"
                            :data-vv-as="$t('participationRelationType.gridHeaders.name')"
                            :name="'participationRelationTypeName' + _uid"
                            :id="'participationRelationTypeName' + _uid"
                        />
                        <span
                            class="text-danger"
                            v-if="errors.has('participationRelationTypeName' + _uid)"
                        >{{ errors.first('participationRelationTypeName' + _uid) }}</span>
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label
                            class="font-weight-bold"
                            :for="'participationRelationTypeNameEn' + _uid"
                        >{{$t('participationRelationType.gridHeaders.nameEn')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.nameEn"
                            :name="'participationRelationTypeNameEn' + _uid"
                            :id="'participationRelationTypeNameEn' + _uid"
                        />
                    </div>

                    <div class="form-group col-12">
                        <label
                            class="font-weight-bold"
                            :for="'participationRelationTypeDescription' + _uid"
                        >{{ $t('participationRelationType.gridHeaders.description')}}</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="model.description"
                            :name="'participationRelationTypeDescription' + _uid"
                            :id="'participationRelationTypeDescription' + _uid"
                        />
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label
                            class="font-weight-bold"
                            :for="'participationRelationTypeSort' + _uid"
                        >{{ $t('participationRelationType.gridHeaders.sort')}}</label>
                        <input
                            type="number"
                            min="1"
                            max="999999"
                            step="1"
                            class="form-control"
                            v-model="model.sort"
                            :name="'participationRelationTypeSort' + _uid"
                            :id="'participationRelationTypeSort' + _uid"
                        />
                    </div>

                    <div class="form-group col-sm-12 col-md-6">
                        <label class="font-weight-bold"></label>
                        <vs-checkbox
                            v-model="model.deactivated"
                            :name="'participationRelationTypeDeactivated' + _uid"
                            :id="'participationRelationTypeDeactivated' + _uid"
                            style="justify-content: flex-start !important"
                        >{{ $t('participationRelationType.gridHeaders.deactivated') }}</vs-checkbox>
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="text-right mt-3">
                    <div
                        class="btn-group"
                        role="group"
                        aria-label="Participation type edit buttons"
                    >
                        <button
                            v-if="hasCreateRights"
                            type="button"
                            class="btn btn-success"
                            @click.stop="onSave"
                            :disabled="saving"
                        >
                            <i v-if="saving" class="fas fa-spinner fa-spin"></i>
                            <i v-else class="fas fa-save mr-2"></i>
                            {{ $t('buttons.save.btnText')}}
                        </button>
                        <button
                            type="button"
                            class="btn btn-danger"
                            @click.stop="onCancel"
                            :disabled="saving"
                        >
                            <i class="fas fa-ban mr-2"></i>
                            {{ $t('buttons.cancel')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ParticipationRelationType } from "../../../models/models";
import { Culture } from "../../../models/enums";
import participationRelationTypeService from "../../../services/participationRelationType.service";

export default {
    inject: ["$validator"],
    props: {
        value: {
            type: ParticipationRelationType,
            required: false,
        },
        create: {
            type: Boolean,
            default: false,
        },
    },
    components: {},
    data() {
        return {
            model: this.value,
            saving: false,
        };
    },
    methods: {
        onCancel() {
            this.$emit("cancel");
        },
        onSave() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.doSave();
                }
            });
        },
        doSave() {
            if (this.create && this.isNew) {
                this.createParticipationType();
            } else {
                this.updateParticipationType();
            }
        },
        createParticipationType() {
            const msg = `${this.$t("participationRelationType.create")}`;
            this.saving = true;

            participationRelationTypeService
                .create(this.model)
                .then((response) => {
                    this.$vs.notify({
                        title: msg,
                        text: this.$helpers.responseMessage(response),
                        color: "success",
                        time: this.$store.getters.notificationDuration,
                    });

                    this.$emit("save", this.model);
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: msg,
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => {
                    this.saving = false;
                });
        },
        updateParticipationType() {
            const msg = `${this.$t("participationRelationType.create")}`;
            this.saving = true;

            participationRelationTypeService
                .update(this.model)
                .then((response) => {
                    this.$vs.notify({
                        title: msg,
                        text: this.$helpers.responseMessage(response),
                        color: "success",
                        time: this.$store.getters.notificationDuration,
                    });

                    this.$emit("save", this.model);
                })
                .catch((error) => {
                    this.$vs.notify({
                        title: msg,
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration,
                    });
                })
                .then(() => {
                    this.saving = false;
                });
        },
    },
    computed: {
        token: function () {
            return this.$store.getters.authToken;
        },
        isEnVersion() {
            return this.$store.getters.currentCulture === Culture.EN;
        },
        isNew() {
            let id = Number(this.model.id);
            return isNaN(id) || id <= 0;
        },
        hasCreateRights() {
            return this.$store.getters.claims.nomenclatureTypes.create;
        },
    },
    mounted() {},
    watch: {
        value: function (val) {
            if (val) {
                this.model = new ParticipationRelationType(this.value);
            }
        },
    },
};
</script>

<style scoped>
input[readonly] {
    background-color: whitesmoke;
}

textarea[readonly] {
    background-color: whitesmoke;
}
</style>
